export default function getLinkTargetPath(node) {
    const href = node.getAttribute('href');

    if (href && href.match(/^http/)) {
        return href.replace(/^http[s]{0,1}:\/\/.[^\/]+[\/]*/, '/');
    }

    return href;
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/dom/getLinkTargetPath.js